import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';
import { getRodRequestStatusColor } from '~/request/styled';
import { RodRequestStatusCode } from '@bechtel/types';

interface RodRequestStatusProps {
  status?: RodRequestStatusCode;
}
export const RodRequestHeaderStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  px: { sm: '500' },
  py: { sm: '450' },
})`
  ${({ theme }) => css`
    background-image: linear-gradient(92deg, ${theme.colors.bechtel.blue[700]}, ${theme.colors.bechtel.blue[1000]});
    height: ${theme.spacings[900]};
  `}
  box-shadow: rgba(0 0 0 / 0.2) 0px 1px 8px 0px, rgba(0 0 0 / 0.12) 0px 3px 3px -2px, rgba(0 0 0 / 0.14) 0px 3px 4px 0px;
`;

export const RodRequestStatusStyled = styled.div<RodRequestStatusProps>`
  ${({ theme }) => css`
    border-radius: ${theme.radii[700]};
    margin-left: ${theme.spacings[500]};
    color: ${theme.colors.white};
  `}
  ${getRodRequestStatusColor}
  ${({ status }) =>
    status === RodRequestStatusCode.PARTIAL_ISSUED &&
    css`
      ${({ theme }) => css`
        background: repeating-linear-gradient(
          110deg,
          ${theme.colors.blue[400]},
          ${theme.colors.blue[400]} ${theme.spacings[450]},
          rgba(17, 17, 17, 0.3) calc(${theme.spacings[450]} + ${theme.spacings[100]}),
          rgba(17, 17, 17, 0.3) calc(${theme.spacings[450]} + ${theme.spacings[100]})
        );
      `}
    `}
`;

export const RodRequestStatusTextStyled = styled.div<RodRequestStatusProps>`
  ${({ theme }) => css`
    margin-top: ${theme.spacings[200]};
    margin-bottom: ${theme.spacings[300]};
    margin-left: ${theme.spacings[450]};
    margin-right: ${theme.spacings[450]};
    font-size: ${theme.fontSizes[300]};
    font-weight: ${theme.fontWeights[300]};
  `}
  text-align: center;
  letter-spacing: 1px;
  ${({ status }) =>
    status === RodRequestStatusCode.PARTIAL_ISSUED &&
    css`
      background-color: rgba(129, 179, 207, 0.73);
    `}
`;

export const HeaderBoxStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
  p: { sm: '450' },
  flexGrow: { sm: 1 },
})`
  ${({ theme }) => css`
    ${(props: RodRequestStatusProps) =>
      props.status === RodRequestStatusCode.CLOSED
        ? css`
            background-color: ${theme.colors.bechtel.blue[700]};
          `
        : css`
            background-color: ${theme.colors.bechtel.blue[600]};
          `}
  `}
`;
